// extracted by mini-css-extract-plugin
export default {"option":"option-selector__option__fCmi6","selected":"option-selector__selected__aDVZm","disabled":"option-selector__disabled__WcHDh"};